const dashboardLoggerActions = {
  getDashboardLogs: (page, limit, fromDate, toDate, level, method, search) => ({
    type: "GET_DASHBOARD_LOGS",
    payload: { page, limit, fromDate, toDate, level, method, search },
  }),
  getDashboardLogsSuccess: (data) => ({
    type: "GET_DASHBOARD_LOGS_SUCCESS",
    payload: { data },
  }),
  getDashboardLogsFailure: (error) => ({
    type: "GET_DASHBOARD_LOGS_FAILURE",
    payload: { error },
  }),
  deleteLogById: (id) => ({
    type: "DELETE_LOG_BY_ID",
    payload: { id },
  }),
};

export default dashboardLoggerActions;
